import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import CartDrawer from "@/components/CartDrawer";
import Marquee from "@/components/Marquee";
import Hero from "@/sections/Hero";
import LondonSpotlight from "@/sections/LondonSpotlight";
import BonusFeatures from "@/sections/BonusFeatures";
import SeriesBanner from "@/sections/SeriesBanner";
import Collection from "@/sections/Collection";
import SignedBooks from "@/sections/SignedBooks";
import Characters from "@/sections/Characters";
import Worksheets from "@/sections/Worksheets";
import Reviews from "@/sections/Reviews";
import Manifesto from "@/sections/Manifesto";
import Gallery from "@/sections/Gallery";
import Events from "@/sections/Events";
import VideoSection from "@/sections/VideoSection";
import Writers from "@/sections/Writers";
import Schools from "@/sections/Schools";
import Footer from "@/sections/Footer";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!target) return;
    // Wait for the animated/lazy layout to settle, then smooth-scroll to the section
    let last = -1;
    let stable = 0;
    const absTop = (el) => {
      let y = 0;
      let n = el;
      while (n) { y += n.offsetTop; n = n.offsetParent; }
      return y;
    };
    const timer = setInterval(() => {
      const el = document.getElementById(target);
      if (!el) return;
      const top = absTop(el);
      if (top === last) {
        stable += 1;
        if (stable >= 2) {
          clearInterval(timer);
          window.__lenis ? window.__lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView({ behavior: "smooth" });
          window.history.replaceState({}, document.title);
        }
      } else {
        stable = 0;
        last = top;
      }
    }, 250);
    const stop = setTimeout(() => clearInterval(timer), 5000);
    return () => { clearInterval(timer); clearTimeout(stop); };
  }, [location.state]);

  return (
    <div className="grain">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <LondonSpotlight />
        <BonusFeatures />
        <SeriesBanner />
        <Collection />
        <SignedBooks />
        <Characters />
        <Worksheets />
        <Reviews />
        <Manifesto />
        <Gallery />
        <Events />
        <VideoSection />
        <Writers />
        <Schools />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
